import React, { useEffect } from "react";
import "./estimate.css";
const EstimateCard = (appdataState) => {
  const platformdata = JSON.parse(localStorage.getItem("platform"));

  let totalStrings = 0;

  for (const key in appdataState.appdataState) {
    if (Array.isArray(appdataState.appdataState[key])) {
      totalStrings += appdataState.appdataState[key].length;
    }
  }

  return (
    <div className="templateinfo">
      <div class="sidebar">
        <div class="estimate-card" id="estimate-card">
          <h6 class="estimate-title" id="estimate-title">
            PERSONAL ESTIMATE
          </h6>
          <div class="estimate" id="estimate">
            <div class="details">
              <div class="block">
                <span class="title">Platforms</span>
                {platformdata.map((data) => {
                  return <span class="item">{data}</span>;
                })}

                <div class="hover">
                  <span class="title">Platforms</span>
                  {platformdata.map((data) => {
                    return <span class="item">{data}</span>;
                  })}
                </div>
                <div class="delimiter"></div>
              </div>
              <div class="block">
                <span class="title">App size</span>
                {appdataState?.appdataState?.size?.map((data) => {
                  return <span class="item">{data}</span>;
                })}
                <div class="hover">
                  <span class="title">App size</span>
                  {appdataState?.appdataState?.size?.map((data) => {
                    return <span class="item">{data}</span>;
                  })}
                </div>
                <div class="delimiter"></div>
              </div>
              <div class="block">
                <span class="title">UI level</span>
                {appdataState?.appdataState?.ui?.map((data) => {
                  return <span class="item">{data}</span>;
                })}
                <div class="hover">
                  <span class="title">UI level</span>
                  {appdataState?.appdataState?.ui?.map((data) => {
                    return <span class="item">{data}</span>;
                  })}
                </div>
                <div class="delimiter"></div>
              </div>
              <div class="block">
                <span class="title">Users &amp; Accounts</span>
                {appdataState?.appdataState?.account?.map((data, index) => {
                  const displayData = index === 0 ? data : null;
                  return <span class="item">{displayData}</span>;
                })}
                <div class="hover">
                  <span class="title">Users &amp; Accounts</span>
                  {appdataState?.appdataState?.account?.map((data) => {
                    return <span class="item">{data}</span>;
                  })}
                </div>
                <div class="delimiter"></div>
              </div>
              <div class="block">
                <span class="title">User Generated Content</span>
                {appdataState?.appdataState?.user?.map((data, index) => {
                  const displayData = index === 0 ? data : null;
                  return <span class="item">{displayData}</span>;
                })}
                <div class="hover">
                  <span class="title">User Generated Content</span>
                  {appdataState?.appdataState?.user?.map((data, index) => {
                    return <span class="item">{data}</span>;
                  })}
                </div>
                <div class="delimiter"></div>
              </div>
              <div class="block">
                <span class="title">Mobile specific features</span>

                <div class="hover">
                  <span class="title">Mobile specific features</span>
                </div>
                <div class="delimiter"></div>
              </div>
              <div class="block">
                <span class="title">Dates &amp; Locations</span>
                {appdataState?.appdataState?.date?.map((data, index) => {
                  const displayData = index === 0 ? data : null;
                  return <span class="item">{displayData}</span>;
                })}
                <div class="hover">
                  <span class="title">Dates &amp; Locations</span>
                  {appdataState?.appdataState?.date?.map((data, index) => {
                    return <span class="item">{data}</span>;
                  })}
                </div>
                <div class="delimiter"></div>
              </div>
              <div class="block">
                <span class="title">Social &amp; Engagement</span>
                {appdataState?.appdataState?.social?.map((data, index) => {
                  const displayData = index === 0 ? data : null;
                  return <span class="item">{displayData}</span>;
                })}

                <div class="hover">
                  <span class="title">Social &amp; Engagement</span>
                  {appdataState?.appdataState?.social?.map((data, index) => {
                    return <span class="item">{data}</span>;
                  })}
                </div>
                <div class="delimiter"></div>
              </div>
              <div class="block">
                <span class="title">Billing &amp; eCommerce</span>
                {appdataState?.appdataState?.billing?.map((data, index) => {
                  const displayData = index === 0 ? data : null;
                  return <span class="item">{displayData}</span>;
                })}
                <div class="hover">
                  <span class="title">Billing &amp; eCommerce</span>
                  {appdataState?.appdataState?.billing?.map((data, index) => {
                    return <span class="item">{data}</span>;
                  })}
                </div>
                <div class="delimiter"></div>
              </div>
              <div class="block">
                <span class="title">Admin, Feedback &amp; Analytics</span>
                {appdataState?.appdataState?.admin?.map((data, index) => {
                  const displayData = index === 0 ? data : null;
                  return <span class="item">{displayData}</span>;
                })}
                <div class="hover">
                  <span class="title">Admin, Feedback &amp; Analytics</span>
                  {appdataState?.appdataState?.admin?.map((data, index) => {
                    return <span class="item">{data}</span>;
                  })}
                </div>
                <div class="delimiter"></div>
              </div>
              <div class="block">
                <span class="title">External APIs and Integrations Hours</span>
                {appdataState?.appdataState?.integration?.map((data, index) => {
                  const displayData = index === 0 ? data : null;
                  return <span class="item">{displayData}</span>;
                })}
                <div class="hover">
                  <span class="title">
                    External APIs and Integrations Hours
                  </span>
                  {appdataState?.appdataState?.integration?.map(
                    (data, index) => {
                      return <span class="item">{data}</span>;
                    }
                  )}
                </div>
                <div class="delimiter"></div>
              </div>
              <div class="block">
                <span class="title">Security Hours</span>
                {appdataState?.appdataState?.security?.map((data, index) => {
                  const displayData = index === 0 ? data : null;
                  return <span class="item">{displayData}</span>;
                })}
                <div class="hover">
                  <span class="title">Security Hours</span>
                  {appdataState?.appdataState?.security?.map((data, index) => {
                    return <span class="item">{data}</span>;
                  })}
                </div>
                <div class="delimiter"></div>
              </div>
              <div class="block">
                <span class="title">App Specific Development Hours</span>
                {appdataState?.appdataState?.specific?.map((data, index) => {
                  const displayData = index === 0 ? data : null;
                  return <span class="item">{displayData}</span>;
                })}
                <div class="hover">
                  <span class="title">App Specific Development Hours</span>
                  {appdataState?.appdataState?.specific?.map((data) => {
                    return <span class="item">{data}</span>;
                  })}
                </div>
                <div class="delimiter"></div>
              </div>
            </div>
            <div class="separator"></div>
            <div class="summary">
              <div class="price">
                <div class="block">
                  <span class="title">Designer man/hours</span>
                  <span class="item">{totalStrings *2}</span>
                  <div class="hover">
                    <span class="title">Designer man/hours</span>
                    <span class="item">{totalStrings * 2}</span>
                  </div>
                  <div class="delimiter"></div>
                </div>
                <div class="block">
                  <span class="title">Developer man/hours</span>
                  <span class="item">{totalStrings * 3}</span>
                  <div class="hover">
                    <span class="title">Developer man/hours</span>
                    <span class="item">{totalStrings * 3}</span>
                  </div>
                  <div class="delimiter"></div>
                </div>
              </div>
              <div class="price">
                <div class="block">
                  <span class="title">Total man/hours</span>
                  <span class="item">{(totalStrings * 5) }</span>
                  <div class="hover">
                    <span class="title">Total man/hours</span>
                    <span class="item">{(totalStrings * 5) }</span>
                  </div>
                  <div class="delimiter"></div>
                </div>
                <div class="block">
                  <span class="title">Budget</span>
                  <span class="item">${totalStrings * 50}</span>
                  <div class="hover">
                    <span class="title">Budget</span>
                    <span class="item">${totalStrings * 50}</span>
                  </div>
                  <div class="delimiter"></div>
                </div>
              </div>
            </div>
            <div class="estimate-scroll">More details</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EstimateCard;
